<mat-card [ngSwitch]="item?.status" class="contrast" [class.banner-info]="selected" [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content *ngSwitchCase="partnershipStatus.Requested" fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
      <strong [ngClass.lt-sm]="{'card-title': true}">{{ getCompanyName(item) }}</strong>
    </div>
    <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div [fxFlex]="readonly ? 100 : 70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <p><small>{{ getDateText(item) }}</small></p>
        <div>&nbsp;{{ item?.dateModified | date }}</div>
      </div>
      <div *ngIf="!readonly" fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
        <button
          *ngIf="!isInitiater(item)"
          mat-icon-button color="accent"
          aria-label="Review the Partnership Request"
          matTooltip="Review Partnership Request"
          (click)="viewPartnership(item)"
          [disabled]="loading">
          <mat-icon>link</mat-icon>
        </button>
        <button 
          *ngIf="isInitiater(item)"
          mat-icon-button color="warn"
          aria-label="Cancel the Partnership Request"
          matTooltip="Cancel Partnership Request"
          (click)="cancelPartnershipRequest(item)"
          [class.button-spinner]="loading && transitionStatus === partnershipStatus.Cancelled"
          [disabled]="loading">
          <mat-icon>link_off</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-content *ngSwitchCase="partnershipStatus.Approved" fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
      <strong [ngClass.lt-sm]="{'card-title': true}">{{ getCompanyName(item) }}</strong>
    </div>
    <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div [fxFlex]="readonly ? 100 : 70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <p><small>{{ getDateText(item) }}</small></p>
        <div>&nbsp;{{ item?.dateModified | date }}</div>
      </div>
      <div *ngIf="!readonly" fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
        <button 
          mat-icon-button color="accent"
          aria-label="View the Partnership"
          matTooltip="View Partnership"
          (click)="viewPartnership(item)"
          [disabled]="loading">
          <mat-icon>link</mat-icon>
        </button>
        <button
          mat-icon-button color="warn"
          aria-label="Terminate the Partnership"
          matTooltip="Terminate Partnership"
          (click)="terminatePartnership(item)"
          [disabled]="loading">
          <mat-icon>link_off</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-content *ngSwitchCase="partnershipStatus.Reconnected" fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
      <strong [ngClass.lt-sm]="{'card-title': true}">{{ getCompanyName(item) }}</strong>
    </div>
    <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div [fxFlex]="readonly ? 100 : 70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <p><small>{{ getDateText(item) }}</small></p>
        <div>&nbsp;{{ item?.dateModified | date }}</div>
      </div>
      <div *ngIf="!readonly" fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
        <button 
          mat-icon-button color="accent"
          aria-label="View the Partnership"
          matTooltip="View Partnership"
          (click)="viewPartnership(item)"
          [disabled]="loading">
          <mat-icon>link</mat-icon>
        </button>
        <button
          mat-icon-button color="warn"
          aria-label="Terminate the Partnership"
          matTooltip="Terminate Partnership"
          (click)="terminatePartnership(item)"
          [class.button-spinner]="loading && transitionStatus === partnershipStatus.Terminated"
          [disabled]="loading">
          <mat-icon>link_off</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-content *ngSwitchCase="partnershipStatus.Terminated" fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
      <strong>{{ getCompanyName(item) }}</strong>
    </div>
    <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div [fxFlex]="readonly ? 100 : 70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <p><small>{{ getDateText(item) }}</small></p>
        <div>&nbsp;{{ item?.dateModified | date }}</div>
      </div>
      <div *ngIf="!readonly" fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
        <button mat-icon-button color="primary"
          aria-label="Reconnect the Partnership"
          matTooltip="Reconnect Partnership"
          (click)="reconnectPartnership(item)"
          [class.button-spinner]="loading && transitionStatus === partnershipStatus.Reconnected"
          [disabled]="loading || companyId !== item.modifiedByCompanyId">
          <mat-icon>add_link</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>